import React, { useContext } from 'react';
import { Context } from '@front10/helpers/dist/Context';
import ImageHeader from '../../../elements/ImageHeader';
import Text from '../../../elements/Text';
import Box from '../../../elements/Box';

const ImagesCarousel = ({
  data: { alt, url },
  showAltText = false,
  altTextLabelKey = 'cmp-lowest-rates-properties-stay-in',
  altTextSettings,
  textSettings,
  imageHeader,
  containerTextSettings = {}
}) => {
  const { translate } = useContext(Context);

  return (
    <ImageHeader image={url} imageHeight={190} marginHeight={'5px'} {...imageHeader}>
      <Box
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
        alignItems={'center'}
        height={'100'}
        textAlign={'center'}
        {...containerTextSettings}
      >
        {showAltText && <Text {...altTextSettings}>{translate(altTextLabelKey, 'Stay in')}</Text>}
        <Text {...textSettings}>{alt}</Text>
      </Box>
    </ImageHeader>
  );
};

export default ImagesCarousel;
